/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetMarketsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetMarketsArgs, useGetMarketsSpec, useGetMarketsRealtime, useGetMarketsPagination } from '../specs/markets.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetMarketsRow } from '../openapi-types.gen.js';
export type { useGetMarketsArgs } from '../specs/markets.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetMarketsPaginationContract = useGetMarketsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetMarketsInfinite` — both
 * read/write the same `PagedData<GetMarketsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): eventId, resolutionMode, marketType, classification, status, statusNot, category, location, boostLocation, search, creator, creatorUserId, pubkeys, volumeMin, volumeMax, createdAfter, createdBefore, outcomesMin, outcomesMax, prizePoolMin, prizePoolMax, liquidityMin, liquidityMax, backersMin, backersMax, tradersMin, tradersMax, sortBy, sortOrder, limit, cursor.
 */
export const useGetMarkets = createListHook({
  spec: useGetMarketsSpec,
  realtime: useGetMarketsRealtime,
  entityKey: 'market',
  pagination: _useGetMarketsPaginationContract,
});


/**
 * Auto-infinite: same cache as `useGetMarkets`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetMarkets` for "Load more"
 * buttons / non-scroll UX.
 */
export const useGetMarketsInfinite = createListHook({
  spec: useGetMarketsSpec,
  realtime: useGetMarketsRealtime,
  entityKey: 'market',
  pagination: _useGetMarketsPaginationContract,
  autoLoadMore: true,
});


/**
 * Per-field subscription hook for the `useGetMarkets` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetMarketsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetMarketsField = createFieldHook<GetMarketsRow>('useGetMarketsField');

/**
 * Hover/intent prefetch companion for `useGetMarkets` (also covers
 * `useGetMarketsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetMarkets();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetMarkets = createPrefetchHook(useGetMarketsSpec);
